var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg333Oh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "333oh 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.473 332.997C298.473 330.195 298.473 327.755 298.473 324.785C283.751 324.785 269.299 324.8 254.847 324.782C235.69 324.759 216.531 324.854 197.375 324.616C187.073 324.487 179.083 317.4 177.047 307.33C175.194 298.167 180.081 288.251 189.059 284.344C192.44 282.872 196.461 282.307 200.194 282.293C241.007 282.154 281.823 282.302 322.637 282.132C331.76 282.094 338.012 286.355 344.266 292.525C369.526 317.444 395.221 341.922 420.754 366.566C424.35 370.037 427.658 373.879 431.592 376.911C437.807 381.698 439.85 387.491 439.635 395.36C439.082 415.503 439.449 435.672 439.451 455.83C439.451 458.257 439.451 460.684 439.451 464.311C429.928 455.15 421.763 446.623 412.887 438.913C399.205 427.028 385.092 415.636 371.051 404.169C362.528 397.207 352.266 394.772 341.629 394.859C318.496 395.051 295.368 396.096 272.235 396.293C243.914 396.535 215.583 395.927 187.267 396.372C174.635 396.571 164.266 391.87 155.786 383.611C125.951 354.553 96.579 325.021 67.023 295.678C60.419 289.121 58.795 281.216 61.803 272.731C64.715 264.515 71.071 259.846 79.806 258.981C86.685 258.299 92.402 260.981 97.41 265.675C117.098 284.131 136.87 302.5 156.612 320.899C160.389 324.42 164.08 328.043 168.008 331.385C169.276 332.465 171.174 333.39 172.786 333.394C214.104 333.479 255.422 333.434 296.739 333.396C297.211 333.396 297.681 333.186 298.473 332.997Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M187.18 43.322H131.259V99.243H187.18V43.322Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M265.47 43.322H209.549V99.243H265.47V43.322Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M343.76 43.322H287.838V99.243H343.76V43.322Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M187.46 121.612H131.539V177.533H187.46V121.612Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M265.75 121.612H209.828V177.533H265.75V121.612Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M344.039 121.612H288.117V177.533H344.039V121.612Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M187.6 199.901H131.679V255.822H187.6V199.901Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M265.888 199.901H209.968V255.822H265.888V199.901Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M344.178 199.901H288.258V255.822H344.178V199.901Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg333Oh);
export default __webpack_public_path__ + "static/media/333oh.0fa33b24066f93ad8966056ef0081807.svg";
export { ForwardRef as ReactComponent };